module.exports = __webpack_public_path__ + "static/media/2.24.b4a8663d.png";